document.addEventListener('DOMContentLoaded', function() {
  // Berechnet den nächsten Donnerstag der Folgewoche
  function getNextWeekThursday() {
    const today = new Date();
    const currentDay = today.getDay();
    const isoDay = (currentDay === 0) ? 7 : currentDay;
    const mondayThisWeek = new Date(today);
    mondayThisWeek.setDate(today.getDate() - (isoDay - 1));
    const nextThursday = new Date(mondayThisWeek);
    nextThursday.setDate(mondayThisWeek.getDate() + 10);
    return nextThursday;
  }

  // Formatierung des Datums
  function formatDate(date) {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${day}.${month}.${year}`;
  }

  // Einmalige Berechnung und globale Speicherung
  const computedDate = formatDate(getNextWeekThursday());
  window.lieferdatumComputed = computedDate;

  // Aktualisiert alle .lieferdatum-value Elemente, wenn diese noch keinen Text haben
  function updateLieferdatum() {
    document.querySelectorAll('.lieferdatum-value').forEach(function(el) {
      // Falls der Inhalt bereits gesetzt wurde, überspringen wir ihn
      if (!el.textContent.trim()) {
        const container = el.closest('.lieferdatum-container');
        if (container && container.dataset.lieferungEnde === "true") {
          el.textContent = "Ende " + new Date().getFullYear();
        } else {
          el.textContent = computedDate;
        }
        el.classList.remove("skeleton");
        // Optional: Setze einen Marker, falls du den Block nicht erneut updaten möchtest
        el.dataset.lieferdatumSet = "true";
      }
    });
  }

  // Beim initialen Pageload ausführen
  updateLieferdatum();

  // ----- URL-Änderungen abfangen (pushState/replaceState) -----
  (function(history){
    const pushState = history.pushState;
    history.pushState = function(state) {
      const ret = pushState.apply(history, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return ret;
    };
  })(window.history);

  (function(history){
    const replaceState = history.replaceState;
    history.replaceState = function(state) {
      const ret = replaceState.apply(history, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return ret;
    };
  })(window.history);

  window.addEventListener('popstate', function(){
    window.dispatchEvent(new Event('locationchange'));
  });
  // ----- Ende URL-Änderungen abfangen -----

  // Event-Listener, der bei URL-Änderung das Lieferdatum aktualisiert
  window.addEventListener('locationchange', function(){
    // Kurz warten, bis die neuen DOM-Elemente (z. B. in der Buy Box) vorhanden sind
    setTimeout(function() {
      updateLieferdatum();
    }, 100);
  });
});
